var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { BaseInput } from '../ui';
import { FormField } from './form-field';
export var Checkbox = forwardRef(function (_a, ref) {
    var label = _a.label, error = _a.error, description = _a.description, _b = _a.className, className = _b === void 0 ? '' : _b, width = _a.width, _c = _a.labelClassName, labelClassName = _c === void 0 ? '' : _c, _d = _a.containerClassName, containerClassName = _d === void 0 ? '' : _d, _e = _a.isRequired, isRequired = _e === void 0 ? false : _e, props = __rest(_a, ["label", "error", "description", "className", "width", "labelClassName", "containerClassName", "isRequired"]);
    var id = React.useId();
    return (_jsx(FormField, { label: label, error: error, description: description, htmlFor: id, orientation: 'horizontal', labelPosition: 'right', labelVariant: 'label', width: width, labelClassName: labelClassName, className: containerClassName, isRequired: isRequired, children: _jsx(BaseInput, __assign({ ref: ref, id: id, type: 'checkbox', hasError: !!error, className: "!h-4 !w-4 !rounded !accent-vjwAccent ".concat(className) }, props)) }));
});
Checkbox.displayName = 'Checkbox';
